import { render, staticRenderFns } from "./exchangeCode.vue?vue&type=template&id=0c1b719a&"
import script from "./exchangeCode.vue?vue&type=script&lang=js&"
export * from "./exchangeCode.vue?vue&type=script&lang=js&"
import style0 from "./exchangeCode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports